import React from "react";
import { withRouter } from "react-router-dom";

import { Grid, Typography } from "@material-ui/core";

import useStyles from "./styles";

const CardHeader = ({ history, owner, campaignLocation }) => {
  const {
    cHeader,
    cOwnerInfoWrapper,
    cOwnerAvatar,
    cOwnerInfo,
    cOwnerName,
    cLocation
  } = useStyles({ avatar: owner.avatar });
  return (
    <Grid
      item
      container
      className={cHeader}
      onClick={() => history.push(`/companies/${owner.id}`)}
    >
      <Grid item container xs={12} justify="center">
        <Grid item container xs={9} className={cOwnerInfoWrapper}>
          <Grid item container xs className={cOwnerAvatar} />
          <Grid item container xs className={cOwnerInfo}>
            <Grid item>
              <Typography className={cOwnerName} noWrap>
                {owner.company_profile}
              </Typography>
            </Grid>
            <Grid item>
              <Typography className={cLocation} noWrap>
                {campaignLocation}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withRouter(CardHeader);
